export default __webpack_public_path__ + "static/dan_liden-b21c41fa5e521524907a2091f878539b.jpg";